<template>
    <div class="px-4 pt-4">
        <div class="grid grid-cols-3 border-b border-a-brown-d7c7b8 pb-4">
            <div>
                <div class="campaign-image rounded-10" :style="{'background-image': `url('${purchase.fullImageUrl}')`}"></div>
            </div>
            <div class="col-span-2 pl-2">
                <div class="text-14 text-a-brown-502314 text-2-line">{{purchase.name}}</div>
                <div class="text-12 text-a-brown-9f8273 mt-2">{{lbl.history.expire_on}} {{FiterDateFormatFull(purchase.voucherExpireDate)}}</div>
                <div class="text-12 text-a-brown-9f8273 mt-2" v-if="purchase.pointPerUnit != null">
                    {{lbl.history.use_point}} <span class="text-12 text-a-red-d62300"><span v-if="purchase.pointPerUnit > 0">-</span>{{FilterNumberFormat(purchase.pointPerUnit)}}</span>
                </div>
                <!-- <div>{{getPointMessage()}}</div>
                <div v-if="isShowPurchaseMsg" v-html="purchaseMessage"></div>
                <div v-if="isShowDelivery">{{deliveryMessage}}</div>
                <div v-if="isShipped">{{purchase.parcelNo}}</div>
                <div v-if="isShowPrivilegeMessage" v-html="privilegeMessage"></div> -->
                <div class="flex mt-2" v-if="purchase?.isSubscriptionCoupon">
                    <div v-show="isExpired" class="text-12 text-a-brown-9f8273">
                        {{lbl.history.status}}  <span class="text-a-brown-502314">{{ purchaseMessage }}</span>
                    </div>
                    <div v-show="!isExpired" class="text-12 text-a-brown-9f8273">
                        <div v-show="purchase.isUsed">
                            {{lbl.history.status}}  <span class="text-a-brown-502314">{{ purchaseMessage }}</span>
                        </div>
                        <div v-show="!purchase.isUsed && isActive" class="inline-block">
                            {{lbl.history.status}} 
                            <RedButton customClass="py-1 px-3 ml-2" @click="clickPurchase()">
                                <div class="text-12">{{purchaseMessage}}</div>
                            </RedButton>
                        </div>
                    </div>
                </div>
                <div class="flex mt-2" v-else>
                    <div v-show="!isExpired && !purchase.isUsed" class="inline-block">
                        <div class="text-12 text-a-brown-9f8273 inline-block">
                            {{lbl.history.status}} 
                        </div>
                        
                        <RedButton customClass="py-1 px-3 ml-2" @click="clickPurchase()">
                            <div class="text-12">{{purchaseMessage}}</div>
                        </RedButton>
                    </div>
                    <div v-show="purchase.isUsed && !isExpired" class="text-12 text-a-brown-9f8273">
                        {{lbl.history.status}}  <span class="text-a-brown-502314">{{lbl.history.used}}</span>
                    </div>
                    <div v-show="isExpired" class="text-12 text-a-brown-9f8273">
                        {{lbl.history.status}}  <span class="text-a-brown-502314">{{lbl.history.expire}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import RedButton from '@/components/Button/RedButton.vue';

/**
 * @event onClickPurchase
 */
export default {
    name: 'HistoryItem',
    mixins: [LocaleMixin],
    components: {
        RedButton,
    },
    props: {
        purchase: { type: Object, required: true },
    },
    data: function() {
        return {
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            isExpired: false,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.
        };
    },
    created: function() {
        this.initialPurchase();
    },
    computed: {
        isShowPurchaseMsg: function() {
            return this.type == 'purchase' || this.type == 'draw' || this.type == 'interface';
        },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lbl.history.get_point : this.lbl.history.use_point;
            var pointUnit = this.lbl.history.point + (this.purchase.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat && this.purchase.privilegeMessageFormat.toLowerCase() === 'html') {
                this.isShowPrivilegeMessage = false;
            }

            //purchase message.
            switch(this.purchase.type) {
                case CampaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lbl.purchase.not_draw1 + (this.lbl.purchase.not_draw2 ? ' ' + this.lbl.purchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lbl.purchase.draw_winner1 + (this.lbl.purchase.draw_winner2 ? ' ' + this.lbl.purchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage) {
                                this.purchaseMessage += "<br>" + this.purchase.adsMessage;
                            }
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lbl.purchase.draw_not_win1 + (this.lbl.purchase.draw_not_win2 ? ' ' + this.lbl.purchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case CampaignType.Buy:
                case CampaignType.Free:
                case CampaignType.Deal:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.isExpired = true;
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                    } else {
                        this.isActive = true;
                        this.purchaseMessage = this.lbl.history.view_code;
                    }
                    break;
                case CampaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get") {
                            this.purchaseMessage = this.lbl.purchase.interface_get;
                        }
                        else {
                            this.purchaseMessage = this.lbl.purchase.interface_use;
                        }
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lbl.purchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lbl.purchase.delivery;
                }
            }

            //subscription.
            if (this.purchase?.isSubscriptionCoupon) {
                if (this.purchase.serial == "XXXXXXX" && !this.purchase.isUsed) {
                    this.isExpired = true;
                    this.purchaseMessage = this.lbl.purchase.code_expired;
                } else if (this.purchase.isUsed) {
                    this.isActive = false;
                    this.purchaseMessage = this.lbl.history.used;
                } else {
                    this.isActive = true;
                    this.purchaseMessage = this.lbl.history.view_code;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },

        clickPurchase: function() {
            this.$emit('onClickPurchase', this.purchase);
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/image.scss";

    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
